import { styled } from '@mui/material/styles'
import { Box, Button, Typography } from '@mui/material'

export const CategoryTags = styled(Box)({
  display: 'flex',
  gap: '12px',
  marginBottom: '62px',
  justifyContent: 'center',
})

export const CategoryTag = styled(Button)({
  backgroundColor: '#251E0F',
  height: 'fit-content',
  color: '#FEB820',
  padding: '3px 26px',
  borderRadius: '14.5px',
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '1.63px',
  textTransform: 'uppercase',
  minWidth: 'unset',
  '&:hover': {
    backgroundColor: '#251E0F',
  },
})

export const PageTitle = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '36px',
  lineHeight: '16px',
  letterSpacing: '-0.5px',
  textAlign: 'center',
  color: 'rgba(255, 255, 255, 1)',
  marginBottom: '24px',
})

export const FollowersContainer = styled(Box)({
  background: '#000000',
  borderRadius: '24px',
  padding: '36px',
  margin: '16px auto',
})

export const ProfileHeader = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginBottom: '24px',
})

export const ProfileImage = styled('img')({
  width: '54px',
  height: '54px',
  borderRadius: '50%',
})

export const ProfileInfo = styled(Box)({
  flex: 1,
})

export const ProfileName = styled(Typography)({
  color: 'white',
  fontSize: '21px',
  fontWeight: 400,
  marginBottom: '4px',
  wordBreak: 'break-all',
})

export const ProfileSubtext = styled(Typography)({
  color: '#c1c1c1',
  fontSize: '12px',
  fontWeight: 400,
})

export const MainContent = styled(Box)({
  display: 'flex',
  gap: '50px',
})

export const LeftSection = styled(Box)({
  width: '214px',
  // wordBreak: 'break-all',
})

export const RightSection = styled(Box)({
  flex: 1,
})

export const Tag = styled(Box)({
  fontFamily: 'Alexandria',
  fontWeight: 700,
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'start',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: '#00c2e5',
  width: '100%',
})

export const TagText = styled(Box)({
  padding: '6px 21px',
  borderRadius: '14.5px',
  background: '#001317',
  // width: '140px',
  textAlign: 'center',
  wordBreak: 'break-all',
})

export const TagCount = styled('span')({
  color: '#ffffff',
  fontSize: '12px',
})

export const TagsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  // width: '160px',
})

export const SummarySection = styled(Box)({
  marginBottom: '24px',
})

export const SummaryTitle = styled(Typography)({
  color: 'white',
  fontSize: '20px',
  fontWeight: 400,
  marginBottom: '12px',
})

export const SummaryText = styled(Typography)({
  color: 'white',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1.6,
})

export const StatsSection = styled(Box)({
  display: 'flex',
  gap: '48px',
  flexWrap: 'wrap',
})

export const StatColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
})

export const StatLabel = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '20px',
  fontWeight: 400,
  letterSpacing: '1px',
  textTransform: 'uppercase',
})

export const StatValue = styled(Typography)({
  color: '#bfbfbf',
  fontSize: '32px',
  fontWeight: 700,
  border: '1px solid #292929',
  padding: '20px 35px',
  borderRadius: '20px',
})
